import {
  ICajitaLayoutTranslation,
  ICardAsyncFormTranslation,
  ICardFormTranslation,
  ICardSubscriptionAsyncFormTranslation,
  ICashFormTranslation,
  ITransferFormTranslation,
} from "root/shared/MultiLanguage";
import { ITransferSubscriptionTranslation } from "types/cajita_store";
import { IPayoutsCashTranslation } from "types/payouts_cash_form_props";

/**
 * Spanish translation for Cajita Layout
 */
const notAvailableSpanishMessage: string =
  "No se pudo crear la transacción, por favor intente más tarde o comuníquese con la empresa.";
const description: string = "Descripción";
const email: string = "Email";

export const spanishCajitaLayout: ICajitaLayoutTranslation = {
  payButton: ["Pagar"],
  payoutButton: ["Solicitar pago"],
  payinButton: ["Generar orden de pago"],
  selectPaymentMethod: ["Cambiar forma de pago"],
  changePaymentMethod: ["Cambiar forma de pago"],
  selectYourBank: ["Elige tu banco"],
  subscriptionButton: ["Suscribirme"],
  selectorMethods: {
    card: ["Tarjeta de crédito o débito"],
    credit_card: ["Tarjeta de crédito"],
    debit_card: ["Tarjeta de débito"],
    transfer: ["Transferencia"],
    transfer_mxn: ["SPEI (Transferencia Bancaria)"],
    transfer_subscription: ["Débito recurrente"],
    cash: ["Efectivo"],
    payouts_cash: ["Pagos en efectivo"],
    card_async: ["Tarjeta de débito"],
    card_dynamic: ["Tarjeta de crédito o débito"],
    card_subscription_dynamic: ["Subscripción"],
    card_subscription_async: ["Suscripción de Tarjeta"],
  },
  notAvailable: [
    "Lo sentimos, Kushki no se encuentra disponible en el momento",
  ],
  notAvailableTransfer: [notAvailableSpanishMessage],
  notAvailableCash: [notAvailableSpanishMessage],
  notAvailableCardAsync: [notAvailableSpanishMessage],
  notAvailableCardSubscriptionAsync: [notAvailableSpanishMessage],
  overlayMessageTitle: ["Un momento"],
  overlayMessageSubtitle: ["Estamos procesando tu pago"],
  cashHelperMessage: [
    "Ingresa tus datos y haz clic en “Generar orden de pago” para recibir los datos necesarios para realizar tu pago en efectivo.",
  ],
  transferHelperMessage: [
    "Ingresa tu e-mail y haz clic en “Generar orden de pago para recibir los datos necesarios para realizar tu transferencia.",
  ],
  payinTotalAmountMessage: [
    // tslint:disable-next-line:no-invalid-template-strings
    "Su orden de pago será generada por ${totalAmount}",
  ],
  footer: {
    learnMore: ["Leer más"],
    secureMessage: [
      "Este pago es procesado de forma segura por Kushki, un proveedor de pagos PCI de nivel 1. ",
    ],
    changeLanguage: ["Cambiar idioma"],
    cardDocumentation: ["¿Cómo realizar un pago con tarjeta de crédito?"],
    pseDocumentation: ["¿Cómo realizar un pago con PSE?"],
  },
  languages: {
    en: ["Inglés"],
    es: ["Español"],
    br: ["Portugués"],
  },
};

/**
 * Spanish translation for cash form
 */

export const spanishCashForm: ICashFormTranslation = {
  description: [description],
  identificationInput: ["Número de documento"],
  lastNameInput: ["Apellido"],
  nameInput: ["Nombre"],
  email: [email],
};

/**
 * Spanish translation for card form
 */

export const spanishCardForm: ICardFormTranslation = {
  cardHolder: ["Nombre y apellido"],
  cardNumber: ["Número de tarjeta"],
  expDate: ["MM/AA"],
  cardCVC: ["CVC"],
  email: [email],
  deferredOptionsComponent: {
    deferredTypeSelectLabel: ["Tipo de diferido"],
    monthsSelectLabel: ["Meses"],
    monthsOfGraceSelectLabel: ["Meses de Gracia"],
    toggleTitle: ["Pagar en cuotas"],
  },
  invalidOtpMessage: ["OTP Inválido"],
  otpKushkiTitle: [
    "Revisa la notificación que te envió tu banco por SMS o email.",
  ],
  otpDinersTitle: [
    "La clave temporal de seguridad se ha enviado a su correo electrónico o celular registrado.",
  ],
  messageDiners: ["Ingrese su clave temporal a continuación:"],
  messageKushki: [
    "Hemos realizado un pequeño cargo a tu tarjeta como HELP_KUSHKI VERIFICACIÓN, que será reversado inmediatamente. El cargo realizado cuenta con tres (3) cifras, las cuales deberás ingresar a continuación:",
  ],
  howItWorks: ["¿Cómo funciona?"],
  otpTitle: ["Verificación"],
  tryWithAnotherCard: ["Intentar con otra tarjeta"],
  otpButtonText: ["Confirmar código"],
  helpText: [
    "El código de seguridad que debe ingresar en los recuadros es un valor aleatorio que recibirá vía SMS o correo electrónico. " +
      "Este valor será debitado en su tarjeta y será reversado inmediatamente sin generarle un gasto adicional al de su compra.",
  ],
  exampleText: {
    firstPhrase: ["Si el cobro que se le notifica por email o SMS fue de"],
    secondPhrase: [", usted debe ingresar en los recuadros:"],
    forExample: ["Por ejemplo"],
  },
  transactionResume: ["Resumen de la transacción"],
  valueToPay: ["Valor a pagar:"],
  numberOffees: ["Número de cuotas:"],
  amountPerFee: ["Valor por cuota:"],
  back: ["Regresar"],
  continue: ["Continuar"],
  commission: {
    link: ["Ver detalle de comisiones"],
    title: ["Detalle de comisiones"],
    text: [
      "A continuación se detalla como se dividen los valores de tu compra:",
    ],
  },
  exceededRetries: {
    title: ["Se han producido demasiados intentos fallidos"],
    description: [
      "No se ha podido completar la verificación porque has fallado demasiados intentos. Vuelve a intentarlo",
    ],
    note: [
      "*Recuerda que el monto que se cargó o debitó de tu tarjeta será reversado inmediatamente",
    ],
    button: ["Intentar con otra tarjeta"],
  },
};

/**
 * Spanish translation for transfer subscription form
 */

export const spanishTransferSubscriptionForm: ITransferSubscriptionTranslation = {
  name: ["Nombre"],
  lastName: ["Apellido"],
  documentType: ["Tipo de documento"],
  documentNumber: ["Número de identificación"],
  accountTypeLabel: ["Tipo de cuenta"],
  accountType: {
    "01": ["Ahorros"],
    "02": ["Corriente"],
  },
  bankId: ["Banco"],
  accountNumber: ["Número de cuenta"],
  email: [email],
  waitMoment: ["¡Un momento!"],
  confrontaDescription: [
    "Por razones de seguridad necesitamos validar algunos datos adicionales pero no te preocupes esto,",
  ],
  confrontaDescriptionStrong: ["lo haremos una sola vez."],
  howItWorks: ["¿Cómo funciona?"],
  dataVerificationLabel: ["Verificación de datos"],
  confirmButtonText: ["Confirmar"],
  cancelButtonText: ["Cancelar"],
  adviceDocumentNumber: [
    "Complete la siguiente información, relacionada con el documento de identidad:",
  ],
  continueButtonText: ["Continuar"],
  selectYourDepartment: ["Seleccione su departamento..."],
  selectYourCity: ["Seleccione su ciudad..."],
  cityLabel: ["Ciudad"],
  departmentLabel: ["Departmento"],
  expeditionDateLabel: ["Fecha de expedición"],
  howItWorksMessage: [
    "Después de validar tus datos de identidad, te mostraremos varias preguntas sobre tus datos personales y/o bancarios que debes contestar correctamente para realizar la transacción.",
  ],
};

/**
 * Spanish translation for card async form
 */
export const spanishCardAsyncForm: ICardAsyncFormTranslation = {
  emailInput: [email],
};

/**
 * Spanish translation for card async form
 */
export const spanishCardSubscriptionAsyncForm: ICardSubscriptionAsyncFormTranslation = {
  emailInput: [email],
  cardNumber: ["Número de tarjeta"],
};

/**
 * Spanish translation for transfer form
 */
export const spanishTransferForm: ITransferFormTranslation = {
  documentEmailInput: ["Correo Electrónico"],
  documentNumberInput: ["Número de Identificación"],
  paymentDescriptionInput: [description],
  bankListSelectLabel: ["Debita desde tu cuenta corriente o de ahorros"],
  userTypeRadioGroupLabel: ["Tipo de persona"],
  userTypeRadioGroup: {
    "0": ["Natural"],
    "1": ["Jurídica"],
  },
};

/**
 * Spanish translation for transfer subscription form
 */

export const spanishPayoutsCashForm: IPayoutsCashTranslation = {
  nameInput: ["Nombre"],
  lastNameInput: ["Apellido"],
  identificationInput: ["Número de documento"],
  description: [description],
  email: ["E-mail"],
};

export enum VALIDATE_3DS_ENUM {
  INVALID = "INVALID",
  VALID = "VALID",
}

export const MESSAGE_3DS_ES_ENUM: Record<VALIDATE_3DS_ENUM, string> = {
  [VALIDATE_3DS_ENUM.INVALID]: "Error al validar 3Ds",
  [VALIDATE_3DS_ENUM.VALID]: "3Ds validado correctamente",
};



// WEBPACK FOOTER //
// ./src/shared/Languages/Spanish.ts